import {Utils} from '@astek/utils';
import {PressureUnitEnum} from '../services/state/pressure-unit.enum';

const MMHG_TO_CMH2O_FACTOR = 1.35951;

export module PressureUnitUtils {
  export function convertMmHgToUnit(pressure: number, unit: PressureUnitEnum): number {
    switch (unit) {
      case PressureUnitEnum.MM_HG:
        return pressure;
      case PressureUnitEnum.CM_H2O:
        return MMHG_TO_CMH2O_FACTOR * pressure;
      default:
        throw new Error(`Unhandled pressure unit '${Utils.enumName(unit, PressureUnitEnum)}'`);
    }
  }

  export function convertUnitToMmHg(pressure: number, unit: PressureUnitEnum): number {
    switch (unit) {
      case PressureUnitEnum.MM_HG:
        return pressure;
      case PressureUnitEnum.CM_H2O:
        return pressure / MMHG_TO_CMH2O_FACTOR;
      default:
        throw new Error(`Unhandled pressure unit '${Utils.enumName(unit, PressureUnitEnum)}'`);
    }
  }

}
